import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    RelationCheckboxes,
    Password,
    CheckBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffUsersNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formUsername, setFormUsername] = useState(null);
    const [formPhone, setFormPhone] = useState(null);
    const [formEmail, setFormEmail] = useState(null);
    const [formTaroffShopId, setFormTaroffShopId] = useState(null);
    const [formUserGroups, setFormUserGroups] = useState([]);
    const [formTaroffShopIdOptions, setFormTaroffShopIdOptions] = useState([]);
    const [formUserGroupsOptions, setFormUserGroupsOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-users-new/select-data/taroff-shop-id').then(
            (response) => {
                setFormTaroffShopIdOptions(response.data);
            }
        );
        postData('/api/panel/page/taroff-users-new/select-data/user-groups').then(
            (response) => {
                setFormUserGroupsOptions(response.data);
            }
        );
    }, []);
    const [formPassword, setFormPassword] = useState(null);
    const [formIsActive, setFormIsActive] = useState(false);
    const [error, setError] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        setError(null);
        try {
            await postData('/api/panel/page/taroff-users-new/save-data', {
                title: formTitle,
                username: formUsername,
                phone: formPhone,
                email: formEmail,
                taroff_shop_id: formTaroffShopId,
                password: formPassword,
                is_active: formIsActive,
                groups: formUserGroups,
            });
        } catch (e) {
            setError(typeof e?.detail === 'string' ? e.detail : 'خطا در ایجاد کاربر');
            return;
        }
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد کاربر</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'نام'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'نام کاربری'}
                            value={formUsername}
                            onChange={setFormUsername}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'شماره همراه'} value={formPhone} onChange={setFormPhone} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'ایمیل'} value={formEmail} onChange={setFormEmail} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'فروشگاه'}
                            options={formTaroffShopIdOptions}
                            value={formTaroffShopId}
                            onChange={setFormTaroffShopId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <Password
                            label={'کلمه عبور'}
                            value={formPassword}
                            onChange={setFormPassword}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox label={'فعال'} value={formIsActive} onChange={setFormIsActive} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <RelationCheckboxes label={'گروه ها'} options={formUserGroupsOptions} value={formUserGroups} onChange={setFormUserGroups} />
                    </GridColumn>
                </Grid>
                {error && <div className="text-red-600 text-xs">{error}</div>}
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
